import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const GetLecturerList = createAsyncThunk('get-lecturer-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}lecturer/get/list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const getLecturerClasses = createAsyncThunk(
  'get-lecturer-subjects',
  async (lecturer_id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}lecturer/get-classes/` + lecturer_id)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getLecturerSemesters = createAsyncThunk(
  'get-lecturer-subjects',
  async (term_class_id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}lecturer/get-semesters/` + term_class_id)
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getLecturerSubjects = createAsyncThunk(
  'get-lecturer-subjects',
  async (params: {term_class_semester_id: string; lecturer_id: string}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}lecturer/get-subjects`, {params})
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getAttendanceData = createAsyncThunk(
  'get-attendance-data',
  async (
    params: {
      lecturer_id: string
      term_class_id: string
      term_class_semester_id: string
      term_semester_subject_id: string
      week_id: string
      date: string
    },
    thunkAPI
  ) => {
    try {
      const response = await axios.get(`${api}lecturer/get-attendance-data`, {params})
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const createLecturerAttendance = createAsyncThunk(
  'attendance-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}lecturer/store-attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const attendanceReport = createAsyncThunk(
  'attendance-report',
  async (
    params: {
      lecturer_id: string
      term_class_id: string
      term_class_semester_id: string
      term_semester_subject_id: []
    },
    thunkAPI
  ) => {
    try {
      const response = await axios.get(`${api}lecturer/attendance-report`, {params})
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getLecturerSalaryPayroll = createAsyncThunk(
  'lecturer-salary-payroll',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}lecturer/generate-salary-payroll`, {
        params: data,
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeLecturerSalaryPayroll = createAsyncThunk(
  'lecturer-payroll-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}lecturer/store-salary-payroll`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const exportLecturerSalaryPayrollExcel = createAsyncThunk(
  'lecturer-payroll-excel',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}lecturer/salary-payroll-excel`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

type lecturerState = {
  errors: any
}

const initialState: lecturerState = {
  errors: '',
}

export const lecturerSlice = createSlice({
  name: 'lecturer',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createLecturerAttendance.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(storeLecturerSalaryPayroll.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = lecturerSlice.actions
export default lecturerSlice.reducer
